import $ from 'jquery';

export default function Auth(vm) {
    this.login = function(params) {
        var url = '/auth/login';

        return vm.post(url, params);
    }

    this.signup = function(params) {
        var url = '/auth/signup';

        return vm.post(url, params);
    }

    this.logout = function() {
        var url = '/auth/logout';

        return vm.get(url);
    }

    this.profile = function() {
        var url = '/auth/profile';

        return vm.get(url);
    }

    this.create = function(params) {
        var url = '/auth/profile';

        return vm.post(url, params);
    }

    this.forgotPassword = function(params) {
        var url = '/auth/forgot-password';

        return vm.post(url, params);
    }

    this.verifyToken = function(params) {
        var url = '/auth/reset-password?' + $.param(params);

        return vm.get(url);
    }

    this.resetPassword = function(params) {
        var url = '/auth/reset-password';

        return vm.post(url, params);
    }

    this.verifyEmail = function() {
        var url = '/auth/verify-email';

        return vm.get(url);
    }

    this.verifyEmailCreate = function(params) {
        var url = '/auth/verify-email';

        return vm.post(url, params);
    }

    this.verifyEmailResend = function(params) {
        var url = '/auth/verify-email/resend';

        return vm.post(url, params);
    }

    this.delete = function() {
        var url = '/auth/profile';

        return vm.delete(url);
    };

    this.verifySession = function() {
        var url = '/auth/verify-session';

        return vm.get(url);
    }

    this.verifySessionCreate = function(params) {
        var url = '/auth/verify-session';

        return vm.post(url, params);
    }

    this.verifySessionResend = function(params) {
        var url = '/auth/verify-session/resend';

        return vm.post(url, params);
    }
}